export enum PageType {
    CREATE = 'create',
    EDIT = 'edit'
}
